<template>
<div class="w-100  bg-dark text-white text-center p-1 mt-auto footer">
  <p> <i class="bi bi-c-circle"></i> Copyright Hitech {{currentYear}} - Developed by ACSJ Technic</p>
</div>
</template>

<script> 
export default {
  name:"FooterBottom",
  computed:{
    currentYear(){
      return new Date().getFullYear()
    }
  },
  data() {
    return {
    };
  },
  methods:{ 
  } 
}
</script>
<style >
.footer {
  position: relative;
  bottom: 0px; 
}
</style>